import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ConfirmDialog = ({ open, title, message, confirmLabel = 'Delete', onConfirm, onCancel }) => {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onMouseDown={onCancel} />
      <div className={`relative w-full max-w-md p-6 rounded-xl shadow-xl ${dark ? 'bg-[#1A1A1A] border border-[#333]' : 'bg-white'}`}>
        <h3 className={`text-lg font-semibold mb-2 ${dark ? 'text-white' : 'text-gray-900'}`}>
          {title || 'Confirm Action'}
        </h3>
        <p className={`text-sm mb-6 ${dark ? 'text-gray-400' : 'text-gray-500'}`}>
          {message || 'Are you sure? This action cannot be undone.'}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              dark ? 'text-gray-400 hover:bg-[#333]' : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg text-sm font-medium bg-red-600 text-white hover:bg-red-700"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
